import { CONTENT_MAX_WIDTH } from '@collab/style/customThemeTokens';

const LegalFooter: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <div
    className="mt-64 text-center"
    style={{
      maxWidth: CONTENT_MAX_WIDTH,
    }}
  >
    {typeof children === 'string' ? (
      <p className="text-secondary">{children}</p>
    ) : (
      children
    )}
  </div>
);

export default LegalFooter;
